import { Link } from 'react-router-dom'
import { Compass } from 'lucide-react'

export default function StaffNotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="dash-card max-w-md w-full p-8 text-center">
        <span className="mx-auto w-12 h-12 rounded-full bg-white/[0.06] text-white flex items-center justify-center mb-5"><Compass className="w-5 h-5" /></span>
        <h1 className="text-[20px] font-semibold text-white">This page doesn't exist</h1>
        <p className="mt-2 text-[14px] text-[#8b8d94]">The link may be old, or the page has moved. Press Ctrl+K to search every dashboard page.</p>
        <Link to="/staff" className="dash-btn dash-btn-primary mt-6">Back to dashboard</Link>
      </div>
    </div>
  )
}
